<template>
    <b-overlay :show="loading" rounded="sm">
        <b-card no-body class="card-shadow border-0">
        <b-row no-gutters>
            <b-col 
                md="3" 
                :class="backgroundColor == 'bg-orange' ? 
                    'd-flex align-items-center justify-content-center rounded-left boder-orange': 
                    `d-flex align-items-center justify-content-center rounded-left ${backgroundColor}`"
            >
                <i :class="`${icon} ${iconSize} ${iconColor}`" v-if="icon != 'img-contrucoin'"></i>
                <img v-if="icon == 'img-contrucoin'" src="@/assets/img/coin-logo.png" class="size-img img-fluid rounded" alt="Constru Coin">
            </b-col>
            <b-col md="9">
                <b-card-body>
                    <b-card-title class="c-black font-weight-bold fs-16">
                        {{ title }}
                    </b-card-title>
                    <p v-if="withdrawMoney">R$ {{formatMoneyUn(withdrawMoney)}}</p>
                    <p v-if="!coinQtd && !withdrawMoney && !realMoney"><span v-if="coinQtd == 0">0</span> <span v-else>R$ 0,00</span></p>
                    <p v-if="coinQtd">{{formatCoin(coinQtd)}}</p>
                    <b-row v-if="realMoney">
                        <b-col>
                            <p>R$ {{formatMoneyUn(realMoney)}}</p>
                        </b-col>
                        <b-col cols="4">
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-col>
        </b-row>
        </b-card>
        <b-modal
            title="Sacar Saldo Total"
            size="md"
            id="allowModal"
            v-if="realMoney"
            header-bg-variant="orange"
            no-close-on-backdrop
            header-text-variant="light"
            centered
            hide-header
            hide-footer>
            <withdraw-modal :realMoney="realMoney"></withdraw-modal>
        </b-modal>
    </b-overlay>
</template>
<script>
import WithdrawModal from "./WithdrawModal.vue";
export default {
name: 'ClerkCard',
components: {WithdrawModal},
props: {
    title: {
        type: String,
        required: true,
    },
    icon: {
        type: String,
        required: true,
    },
    coinQtd: {
        type: Number,
        required: false,
    },
    realMoney: {
        type: Number,
        required: false,
    },
    withdrawMoney: {
        type: Number,
        required: false,
        default:0
    },
    iconSize: {
        type: String,
        default: 'fs-28',
    },
    iconColor: {
        type: String,
        default: 'c-white',
    },
    backgroundColor: {
        type: String,
        required: true,
    },
    loading: {
        type: Boolean,
        default: false,
    },
},

methods: {
    formatMoneyUn(value) {
        var money = parseFloat(value);
        return money.toLocaleString('pt-br', {minimumFractionDigits: 2});
    },

    formatCoin(value) {
        var money = parseFloat(value);
        return money.toLocaleString('pt-br');
    },
}
};
</script>
<style scoped>
.card-shadow {
    box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.2);
}
.boder-orange{
    border: 1px solid orange;
}
</style>